<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES EN ORILLAS -->
    <img src="@/assets/flor3.png" class="flor flor-lt" />
    <img src="@/assets/flor3.png" class="flor flor-rb" />

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        />
      </div>
    </div>

    <!-- MODAL -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()
      collageItems.value = collageItems.value.slice(0, images.length)

      const flores = rootRef.value.querySelectorAll('.flor')

      /* ESTADOS INICIALES */
      gsap.set(bgRef.value, { opacity: 0 })
      gsap.set(flores, { opacity: 0, scale: 0.9, y: 20 })
      gsap.set(collageItems.value, { opacity: 0 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          /* 1️⃣ FONDO (rápido) */
          tl.to(bgRef.value, {
            opacity: 1,
            duration: 0.3
          })

          /* 2️⃣ FLORES (rápidas) */
          tl.to(
            flores,
            {
              opacity: 0.55,
              scale: 1,
              y: 0,
              rotate: () => gsap.utils.random(-6, 6),
              duration: 0.4,
              stagger: 0.08
            },
            '+=0.05'
          )

          /* 🌸 FLORES FLOTANTES */
          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 12)}`,
              rotate: gsap.utils.random(-4, 4),
              duration: gsap.utils.random(3, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.25
            })
          })

          /* 3️⃣ FOTO (APARECE CASI INMEDIATO) */
          collageItems.value.forEach((item, i) => {
            if (i === 0) {
              tl.fromTo(
                item,
                { opacity: 0, x: -40, scale: 0.98 },
                {
                  opacity: 1,
                  x: 0,
                  scale: 1,
                  duration: 0.45
                },
                '+=0.05'
              )
            }
          })

          io.disconnect()
        })
      }, { threshold: 0.25 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return {
      images,
      rootRef,
      bgRef,
      collageItems,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal
    }
  }
}
</script>


<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: hidden;
}

/* FONDO ROSA */
.bg-rosa {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, #f7c8d8, #fbe4ec);
  z-index: 0;
}

/* 🌸 FLORES */
.flor {
  position: absolute;
  width: 160px;
  max-width: 45vw;
  opacity: 0;
  pointer-events: none;
  z-index: 1;
}

.flor-lt { top: 6vh; left: -45px; }
.flor-lb { bottom: 6vh; left: -55px; }
.flor-rt { top: 8vh; right: -45px; }
.flor-rb { bottom: 6vh; right: -55px; }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 6vh;
  padding-bottom: 6vh;
}.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  margin-bottom: 10vh;

  display: flex;
  justify-content: center; /* 👈 CENTRA */
}

.collage-image {
  width: 90%;
  margin: 0 auto; /* 👈 CENTRA */
}

.collage-image:hover {
  transform: scale(1.03);
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
}

/* ===== Rasgados ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  z-index: 12;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;

  background-image: url('@/assets/476.avif');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background: linear-gradient(
    to top,
    #f6d5e5 0%,               /* rosa baby base */
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
}

.rasgado-inferior {
  bottom: 0;
  background: #efb6c8;

  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
}


</style>
